import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Contact.css";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const PHONE_NUMBER = "+919755357721";
  const EMAIL = "shriramcarrental1@gmail.com";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Shree Ram Car Rental Indore",
    url: "https://www.shreeramcarrental.com/contact", // ✅ ADDED DOMAIN
    telephone: PHONE_NUMBER,
    email: EMAIL,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_mnv8l04",
        "template_xqdl3of",
        form.current,
        "y_d1tzHWbOth8flx8"
      )
      .then(
        () => {
          alert("✅ Inquiry sent successfully!");
          form.current.reset();
          setLoading(false);
        },
        (error) => {
          console.error(error);
          alert("❌ Failed to send. Call " + PHONE_NUMBER);
          setLoading(false);
        }
      );
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Shree Ram Car Rental Indore</title>

        <meta
          name="description"
          content="Contact Shree Ram Car Rental for self-drive bookings in Indore."
        />

        {/* ✅ CANONICAL URL */}
        <link rel="canonical" href="https://www.shreeramcarrental.com/contact" />

        {/* ✅ STRUCTURED DATA */}
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      <div className="contact-page-dark">
        <div className="bg-glow"></div>

        <header className="contact-header">
          <span className="badge">FAST BOOKING</span>
          <h1>
            Rent Your <span>Dream Car</span>
          </h1>
          <p>Indore's most trusted premium self-drive service.</p>
        </header>

        <section className="contact-grid">

          <div className="contact-sidebar">
            <div className="info-glass-card">

              <div className="info-item">
                <div className="icon">📍</div>
                <div>
                  <h4>Office</h4>
                  <p>Indore, MP (24/7 Delivery)</p>
                </div>
              </div>

              <div className="info-item">
                <div className="icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <a href={`tel:${PHONE_NUMBER}`}>{PHONE_NUMBER}</a>
                </div>
              </div>

              <div className="info-item">
                <div className="icon">📧</div>
                <div>
                  <h4>Email</h4>
                  <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                </div>
              </div>

            </div>

            <div className="support-card">
              <h3>Direct Booking</h3>
              <p>Want a car right now? Tap below to call.</p>
              <a href={`tel:${PHONE_NUMBER}`} className="call-btn-neon">
                Call Now
              </a>
            </div>
          </div>

          <div className="form-wrapper">
            <form
              ref={form}
              onSubmit={handleSubmit}
              className="premium-form"
            >
              <h3>Send Inquiry</h3>

              <input
                type="hidden"
                name="subject"
                value="New Car Rental Inquiry"
              />

              <div className="input-row">
                <div className="input-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="10-digit number"
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Email</label>
                <input
                  type="email"
                  name="user_email"
                  placeholder="example@mail.com"
                  required
                />
              </div>

              <div className="input-group">
                <label>Car Model & Dates</label>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Which car do you want and for which dates?"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="submit-neon"
                disabled={loading}
              >
                {loading ? "Sending..." : "Submit Inquiry →"}
              </button>
            </form>
          </div>

        </section>
      </div>
    </>
  );
};

export default Contact;